import { render, staticRenderFns } from "./SwipePagination.vue?vue&type=template&id=8322a34c&"
import script from "./SwipePagination.vue?vue&type=script&lang=js&"
export * from "./SwipePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports